import DOMPurify from 'dompurify'

/**
 * @params {string} Untrusted HTML
 * @params {object} DOMPurify sanitize options
 * @return {string} Trusted HTML
 */
export const sanitizeHTML = (html, options = {USE_PROFILES: {html: true}}) => {
  return DOMPurify.sanitize(html, options)
}
